import { Routes } from '@angular/router';
import { EditProtectionGelComponent } from './edit-protection-gel/edit-protection-gel.component';
import { ListesProtectionsGelComponent } from './listes-protections-gel/listes-protections-gel.component';

export const PROTECTIONS_GEL_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const PROTECTIONS_GEL_ROUTES: Routes = [
    { path: '', component: ListesProtectionsGelComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditProtectionGelComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditProtectionGelComponent, data: { roles: ['ORGANISME'] } }
];
